import React, { useCallback, useState } from 'react';
import { LogOutNavigationItem } from './LogOutNavigationItem';
import { ProfileDropdown } from './ProfileDropdown';
import { UserIcon } from '@heroicons/react/20/solid';
import { ProfileSlideOver } from './ProfileSlideOver';
import { OutsideClickWrapper } from '../order/overview/Summary/OutsideClickWrapper';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';

export const UserProfileContainer = () => {
  const [showSelfProfile, setShowSelfProfile] = useState<boolean>(false);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const userType = useGetUserType();

  const handleShowSelfProfile = useCallback(() => {
    setShowDropdown(false);
    setShowSelfProfile((prev) => !prev);
  }, []);

  if (userType !== eAccessControlUserType.Admin) {
    return <LogOutNavigationItem />;
  }

  return (
    <OutsideClickWrapper onOutsideClick={() => setShowDropdown(false)}>
      <button type={'button'} onClick={() => setShowDropdown((prev) => !prev)}>
        <UserIcon className={'h-6 w-6'} />
      </button>
      <ProfileDropdown showDropdown={showDropdown} handleShowProfilePage={handleShowSelfProfile} />
      <ProfileSlideOver open={showSelfProfile} setOpen={setShowSelfProfile} />
    </OutsideClickWrapper>
  );
};
